export default class AtlUrl {
  static getParameter(paramName: string) {
    const searchString = window.location.search.substring(1);
    const params = searchString.split("&");

    for (let i=0; i < params.length; i++) {
      let val = params[i].split("=");

      if (val[0] === paramName) {
        return val[1];
      }
    }

    return null;
  }
}
